module.exports = __webpack_public_path__ + "static/media/0_armies.5ab44da4.png";